import { c as _c } from "react/compiler-runtime";
export default function ProductHighs(t0) {
  const $ = _c(11);
  const {
    product
  } = t0;
  let t1;
  if ($[0] !== product?.highs) {
    t1 = product?.highs || [];
    $[0] = product?.highs;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const highs = t1;
  if (!highs.length) {
    return null;
  }
  const t2 = `${product.title} `;
  let t3;
  if ($[2] !== t2) {
    t3 = <h2 className="font-sans font-bold text-base mb-1"><span className="hidden">{t2}</span>Product Highlights</h2>;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== highs) {
    t4 = highs?.length > 0 && highs.map(_temp);
    $[4] = highs;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t4) {
    t5 = <div className="grid grid-cols-1 lg:grid-cols-2 gap-2 mb-2">{t4}</div>;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t3 || $[9] !== t5) {
    t6 = <section>{t3}{t5}</section>;
    $[8] = t3;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
}
function _temp(high, index) {
  return <div key={index} className="flex gap-2 items-center"><svg aria-hidden="true" focusable="false" width="15" height="15" viewBox="0 0 15 15" fill="none"><circle cx="7.5" cy="7.5" r="7.5" fill="#00B67A" /><path d="M4 9L6.5 11L11 5" stroke="white" strokeLinecap="round" /></svg><div className="text-[15px]"><span className="font-medium">{high?.ftitle}{" : "}</span><span className="text-gray-700">{high.fvalue}</span></div></div>;
}